export default __webpack_public_path__ + "static/media/digital-key-high-res.b6949746.png";